import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { BrowserSupportService } from "./browser-support.service";

export const browserSupportGuard: CanActivateFn = () => {
  const browserSupportService = inject(BrowserSupportService);
  const router = inject(Router);

  if (browserSupportService.isSupportedBrowser()) {
    return true;
  }

  return router.createUrlTree(["/unsupported-browser"]);
};
